import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  svg {
    margin: 0 4px -2px 0;
  }
`;
